import { render, staticRenderFns } from "./DataTable2.vue?vue&type=template&id=324785e7&scoped=true"
import script from "./DataTable2.vue?vue&type=script&lang=js"
export * from "./DataTable2.vue?vue&type=script&lang=js"
import style0 from "./DataTable2.vue?vue&type=style&index=0&id=324785e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324785e7",
  null
  
)

export default component.exports